<div class="modal-header p-3 pb-0 d-flex align-items-center justify-content-between" style="border:none !important;">

    <div class="d-flex align-items-center gap-2">
        <app-button *ngIf="canGoBack" buttonType="icon" cssClass="text-dark" [icon]="getIcon('arrow-left')"
            (onClick)="goBack()"></app-button>

        <div *ngIf="currentTitle || currentSubtitle" class="modal-header-text">
            <h4 *ngIf="currentTitle" class="modal-title text-truncate" [title]="currentTitle">
                {{ currentTitle }}
            </h4>
            <div class="d-flex align-items-center">
                <small *ngIf="currentSubtitle" class="text-muted text-truncate" [title]="currentSubtitle">
                    {{ currentSubtitle }}
                </small>
                <ng-content select=".modal-subtitle-extra"></ng-content>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0">
        <ng-content select=".modal-tools"></ng-content>
        <app-button *ngIf="dismissable" buttonType="icon" size="lg" cssClass="text-dark" [icon]="getIcon('close')"
            (onClick)="close()"></app-button>
    </div>

</div>


<div class="modal-body" [ngClass]="{ 'pt-0': !currentTitle && !currentSubtitle, 'px-0': noBodyPadding }">
    <ng-container *ngIf="!isPaginationEnabled">
        <ng-content select=".modal-content"></ng-content>
    </ng-container>

    <ng-container *ngIf="isPaginationEnabled && currentPage">
        <ng-container *ngTemplateOutlet="currentPage.template; context: currentPage.context"></ng-container>
    </ng-container>
</div>

<div class="modal-footer pt-0" *ngIf="currentShowActions">
    <ng-content select=".modal-actions"></ng-content>
</div>
